import { createQueryKeys } from '@lukemorales/query-key-factory';

export const favoriteKeys = createQueryKeys('favorites', {
  list: null,
});
